<template>
  <div class="page_custEmp">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px">
            <el-form-item label="项目:">
              <el-select v-model="listQuery.ProjectId" size="small" filterable clearable placeholder="" style="width: 180px;">
                <el-option v-for="(item, index) in projectList" :key="index" :label="item.StrprojectName" :value="item.Projectid">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="岗位名称" size="small">
              <el-input v-model="listQuery.JobName" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="伴聘岗位" size="small">
              <el-input v-model="listQuery.AppleJobName" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-button v-preventReClick type="success" size="small" @click="searchHandle" style="margin-left: 15px;">搜索</el-button>
          </el-form>
        </div>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item>{{activeName}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="ftabs">
        <!-- <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
          <el-tab-pane label="待面试" name="待面试"></el-tab-pane>
          <el-tab-pane label="待入职" name="待入职"></el-tab-pane>
          <el-tab-pane label="在职" name="在职"></el-tab-pane>
          <el-tab-pane label="离职" name="离职"></el-tab-pane>
        </el-tabs> -->
        <div class="ftabBtn flex">
          <el-button type="primary" size="small" @click="addJob">+添加</el-button>
        </div>

        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%">
          <el-table-column label="项目名称" key="1" prop="ProjectName" min-width="180" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="岗位名称" prop="JobName" key="2" min-width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="伴聘岗位" prop="AppleJobName" key="3" min-width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="创建时间" key="4" prop="CreateTime" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">{{ row.CreateTime ? row.CreateTime.replace('T',' ') : '' }}</template>
          </el-table-column>
          <el-table-column label="操作" min-width="100" align="center">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" @click="editHandel(row)">编辑</el-button>
                <el-popconfirm title="请确认是否删除" @confirm="del(row)" style="margin: 0 10px;">
                  <el-button type="text" slot="reference" size="small">删除</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.currpage" :page-size="Number(listQuery.pagecount)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog :title="editForm.Id ? '编辑' : '添加'" :visible.sync="showEdit" width="500px">
      <el-form :model="editForm" label-width="100px">
        <el-form-item label="项目:">
          <el-select v-model="editForm.ProjectId" size="small" filterable placeholder="" style="width: 220px;" @change="changePro">
            <el-option v-for="(item, index) in projectList" :key="index" :label="item.StrprojectName" :value="item.Projectid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="岗位名称:">
          <el-select v-model="editForm.JobName" size="small" filterable placeholder="" style="width: 220px;">
            <el-option v-for="(item, index) in jobList" :key="index" :label="item.CustomerJobName" :value="item.CustomerJobName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="伴聘岗位:">
          <el-input v-model="editForm.AppleJobName" size="small" clearable style="width: 220px;"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEdit = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmEdit" :loading="isBtnLoading">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import moment from 'moment';
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import {
    e,
    replacer
  } from 'mathjs';
  export default {
    data() {
      return {
        listQuery: {
          ProjectId: null,
          JobName: '',
          AppleJobName: '',
          currpage: 1,
          pagecount: 10,
        },
        jobList: [],
        isBtnLoading: false,
        projectList: [],
        showDropScreen: -1,
        activeName: '',
        tableData: [],
        roletype: localStorage.loginRoletype,
        editForm: {
          Id: "",
          ProjectId: null,
          ProjectName: "",
          JobId: "",
          JobName: "",
          AppleJobName: ""
        },
        totalCount: 0,
        showEdit: false,
        loading: false,
        // 项目名称列表参数
        proNameQuery: {
          searchVal: '',
          pageSize: 100000000,
          pageNum: 1
        },
      }
    },
    created() {
      this.getProNameList();
      this.getList();
    },
    methods: {
      checkPermission,
      // 获取项目列表
      getProNameList() {
        xz.getplancomrecordprojectlist(this.proNameQuery, localStorage.loginRoletype).then(res => {
          // console.log('项目名称列表', res)
          if (res.status == 'ok') {
            this.projectList = res.data
          } else {
            this.projectList = []
          }
        })
      },
      currentChange(val) {
        this.listQuery.currpage = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.currpage = 1;
        this.listQuery.pagecount = val;
        this.getList();
      },
      searchHandle() {
        this.listQuery.currpage = 1;
        this.getList();
      },
      getList() {
        this.loading = true;
        xz.Interview(this.listQuery, this.roletype, 'AppleJobCompareList').then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data;
            this.totalCount = res.totalcount;
            this.loading = false;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      changeTab() {
        this.getList();
      },
      editHandel(row) {
        this.editForm = {
          Id: row.Id,
          ProjectId: Number(row.ProjectId),
          ProjectName: row.ProjectName,
          JobId: row.JobId,
          JobName: row.JobName,
          AppleJobName: row.AppleJobName
        }
        this.getjobList();
        this.showEdit = true;
      },
      addJob() {
        this.editForm = {
          Id: "",
          ProjectId: null,
          ProjectName: "",
          JobId: "",
          JobName: "",
          AppleJobName: ""
        }
        this.showEdit = true;
      },
      changePro(val) {
        if (val) {
          this.editForm.JobName = '';
          let obj = this.projectList.find(item => item.Projectid == val);
          this.editForm.ProjectName = obj.StrprojectName;
          this.getjobList()
        }
      },
      confirmEdit() {
        this.isBtnLoading = true;
        xz.Interview(this.editForm, this.roletype, 'AppleJobCompareOption').then(res => {
          if (res.status == 'ok') {
            this.isBtnLoading = false;
            this.$message.success('修改成功！');
            this.getList();
            this.showEdit = false;
          } else {
            this.$message.error(res.msg)
            this.isBtnLoading = false;
          }
        })
      },
      del(row) {
        this.loading = true;
        xz.Interview({
          id: row.Id
        }, this.roletype, 'AppleJobCompareDel').then(res => {
          if (res.status == 'ok') {
            this.loading = false;
            this.$message.success('删除成功！');
            this.showEdit = false;
            this.getList();
          } else {
            this.$message.error(res.msg)
            this.loading = false;
          }
        })
      },
      //获取搜索中的岗位列表
      getjobList() {
        xz.getresourcejobcustomerlist(localStorage.loginRoletype, {
          projectid: this.editForm.ProjectId
        }).then(res => {
          if (res.status == 'ok') {
            this.jobList = res.data;
          } else {
            this.jobList = [];
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .req {
    color: red;
    margin-right: 8px;
  }

  .dia_label_box {
    max-height: 400px;
    overflow-y: auto;
    margin-bottom: 20px;
  }
</style>
<style>
  .page_custEmp .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_custEmp .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_custEmp .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_custEmp .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_custEmp .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_custEmp .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_custEmp .checkedgroup .el-checkbox {
    margin-right: 10px;
  }

  .page_custEmp .el-checkbox__label {
    padding-left: 3px;
  }

  .page_custEmp .checkedgroup2 .el-checkbox {
    margin-bottom: 5px;
  }

  .dia_label_box .el-checkbox.is-bordered+.el-checkbox.is-bordered {
    margin-left: 0;
  }

  .dia_label_box .el-checkbox.is-bordered.is-checked,
  .dia_label_box .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #19BD92;
  }

  .dia_label_box .el-checkbox {
    border: 1px solid #ddd;
    padding: 2px 3px;
    border-radius: 3px;
    height: auto;
    margin: 5px 20px 0 0;
  }

  .p_resource_module .r_dropDownScreen .el-checkbox__label,
  .dia_label_box .el-checkbox__label {
    padding-left: 3px;
  }
</style>